import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import Ace from 'react-ace';
import { fetchAPIEndpoints } from '../actions/reduxActions/APIEndpoints';
import { notificationTypes } from '../constants';
import { addNotification } from '../actions/reduxActions/notification';
import { stringContains } from '../utils/core';
import BuildSource from '../sources/build';
import Loader from './Loader';
import '../../css/build.less';
import '../../css/notification.less';

import 'brace/mode/json';
import 'brace/theme/twilight';
import 'brace/ext/searchbox';

export class Build extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            url: [],
            description: '',
            isLoading: false,
        };
    }

    componentDidMount() {
        this.props.fetchEndpoints();
    }

    onFilter = (option, { text }) => stringContains(option, text, false);

    onEndpointSelected = (url) => {
        this.setState({ url, input: url.slice().pop() });
    }

    onEndpointKeyUp = (event) => {
        if (event.keyCode === 13 && this.state.input && this.state.input !== '') {
            this.onRequest('GET');
        }
    }

    onInputChange = (input) => {
        this.setState({ input });
    }

    onRequest = (type) => {
        if (!this.state.input || this.state.input === '') {
            return;
        }

        const authenticationToken = (this.state.input.indexOf('api/run') !== -1 ? '' : this.props.currentUser.authenticationToken);
        const body = type === 'GET' ? null : this.state.request;

        this.execute(this.state.input, type, body, authenticationToken, this.props.currentUser.tenantId);
    }

    onRequestChange = (value) => {
        this.setState({ request: value });
    }

    onExecute(response) {
        this.setState({ isLoading: false });

        this.props.addNotification({
            type: notificationTypes.SUCCESS,
            message: `${response.method} to ${response.uri} completed successfully`,
            isPersistent: false,
        });

        const stringifiedResponse = JSON.stringify(response.data, null, 4);

        // If we have an Object, it's probably JSON...
        if (response.data instanceof Object) {
            this.setState({ response: stringifiedResponse, type: 'json' });
        } else {

            /**
             * If the response is not JSON then it could either be
             * a string describing a Flow package or the HTML of
             * a player
             */
            try {

                /**
                 * String can be parsed as JSON, so stringify it again
                 * to unescape it (kind of obfuscates the package data)
                 */
                JSON.parse(response.data);
                this.setState({ response: stringifiedResponse, type: 'json' });
            } catch {

                // String cannot be parsed as JSON, so we assume it is just HTML
                this.setState({ response: response.data, type: 'html' });
            }
        }
    }

    onError(response) {
        this.setState({ isLoading: false });

        this.props.addNotification({
            type: notificationTypes.ERROR,
            message: response.message,
            isPersistent: true,
        });
    }

    execute(uri, method, body, authenticationToken, tenantId) {
        this.setState({ isLoading: true });

        return BuildSource.execute(uri, method, body, authenticationToken, tenantId)
            .then(response => this.onExecute({ data: response, uri, method }))
            .catch(response => this.onError(response));

    }

    render() {
        const urls = Object.keys(this.props.endpoints).map((endpoint) => {
            if (this.props.selectedFlow) {
                return endpoint
                    .replace('{flow}', this.props.selectedFlow.id)
                    .replace('/flow/{id}', `/flow/${this.props.selectedFlow.id}`)
                    .replace('{version}', this.props.selectedFlow.versionId)
                    .replace('{editingToken}', this.props.selectedFlow.editingToken);
            }

            return endpoint;
        });

        return (
            <div className="build">
                <div className="build-endpoint" onKeyUp={this.onEndpointKeyUp} tabIndex={0}>
                    <Typeahead
                        id="typeahead-build"
                        options={urls}
                        selected={this.state.url}
                        onChange={this.onEndpointSelected}
                        onInputChange={this.onInputChange}
                        filterBy={this.onFilter}
                        className="bootstrap-typeahead"
                    />
                    <div className="margin-left">
                        <Button bsStyle="primary" onClick={() => this.onRequest('GET')}>GET</Button>
                        <Button bsStyle="primary" onClick={() => this.onRequest('POST')}>POST</Button>
                        <Button bsStyle="primary" onClick={() => this.onRequest('PUT')}>PUT</Button>
                        <Button bsStyle="danger" onClick={() => this.onRequest('DELETE')}>DELETE</Button>
                    </div>
                </div>
                <span className="help-block">{this.state.description}</span>
                <div className="request-response-container">
                    <div>
                        <h4>Request</h4>
                        <Ace
                            mode="json"
                            theme="twilight"
                            value={this.state.request || ''}
                            scrollBar
                            highlightActiveLine
                            width="auto"
                            height="auto"
                            name="request-editor"
                            onChange={this.onRequestChange}
                        />
                    </div>
                    <div>
                        <h4>Response</h4>
                        <Ace
                            mode={this.state.type}
                            theme="twilight"
                            value={this.state.response || ''}
                            highlightActiveLine
                            width="auto"
                            height="auto"
                            readOnly
                            name="response-editor"
                        />
                    </div>
                </div>
                {this.state.isLoading ? <Loader /> : null}
            </div>
        );

    }

}

const mapStateToProps = ({ APIEndpoints, currentUser }) => ({ 
    currentUser,
    endpoints: APIEndpoints.endpoints, 
    selectedFlow: APIEndpoints.selectedFlow, 
});

const mapDispatchToProps = {
    fetchEndpoints: fetchAPIEndpoints,
    addNotification,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Build);
